'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = require('../utils/underscore');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _reactDom = require('react-dom');

var _Selectors = require('../constants/Selectors');

var _UIDialog = require('./UIDialog');

var _UIDialog2 = _interopRequireDefault(_UIDialog);

var _UIDialogCloseButton = require('./UIDialogCloseButton');

var _UIDialogCloseButton2 = _interopRequireDefault(_UIDialogCloseButton);

var _UIOverlay = require('../overlay/UIOverlay');

var _UIOverlay2 = _interopRequireDefault(_UIOverlay);

var _Dom = require('../utils/Dom');

var _decorators = require('../utils/propTypes/decorators');

var _DialogConstants = require('./DialogConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UIModalDialog = function (_React$Component) {
  _inherits(UIModalDialog, _React$Component);

  function UIModalDialog(props) {
    _classCallCheck(this, UIModalDialog);

    var _this = _possibleConstructorReturn(this, (UIModalDialog.__proto__ || Object.getPrototypeOf(UIModalDialog)).call(this, props));

    _this.state = {
      openComplete: !props._openCompleteRelay
    };

    _this.handleOpenComplete = _this.handleOpenComplete.bind(_this);
    _this.handleCloseStart = _this.handleCloseStart.bind(_this);
    _this.startMutationObserver = _this.startMutationObserver.bind(_this);
    _this.stopMutationObserver = _this.stopMutationObserver.bind(_this);
    _this.captureFocus = _this.captureFocus.bind(_this);
    _this.refCallback = _this.refCallback.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);

    if (props._openCompleteRelay) props._openCompleteRelay.subscribe(_this.handleOpenComplete);
    if (props._closeStartRelay) props._closeStartRelay.subscribe(_this.handleCloseStart);
    return _this;
  }

  _createClass(UIModalDialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
      this.stopMutationObserver();
    }
  }, {
    key: 'handleOpenComplete',
    value: function handleOpenComplete() {
      this.setState({
        openComplete: true
      });

      this.startMutationObserver();
      this.captureFocus();

      var dialog = (0, _reactDom.findDOMNode)(this._ref);
      var focusEl = dialog && dialog.querySelector('[data-modalfocus]');
      if (focusEl) {
        focusEl.focus();
        _devLogger2.default.warn({
          message: 'UIModalDialog: `data-modalfocus` is deprecated. Use `autoFocus`.',
          key: 'UIModalDialog: data-modalfocus'
        });
      }
    }
  }, {
    key: 'handleCloseStart',
    value: function handleCloseStart() {
      if (!this._isMounted) return;
      this.stopMutationObserver();
    }
  }, {
    key: 'startMutationObserver',
    value: function startMutationObserver() {
      if (this._observer) return;
      var dialog = (0, _reactDom.findDOMNode)(this._ref);
      if (!dialog) return;

      // The focus should always be inside of the modal. We may need to recapture
      // it after an update because the focused element may have been unmounted.
      this._observer = new MutationObserver(this.captureFocus);
      this._observer.observe(dialog, {
        attributes: true,
        childList: true,
        subtree: true
      });

      // Disable the mutation observer during blur, as the value of
      // document.activeElement in that phase is misleading.
      window.addEventListener('blur', this.stopMutationObserver, {
        capture: true
      });
      window.addEventListener('focus', this.startMutationObserver, {
        capture: true
      });
    }
  }, {
    key: 'stopMutationObserver',
    value: function stopMutationObserver() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }

      window.removeEventListener('blur', this.stopMutationObserver, {
        capture: true
      });
      window.removeEventListener('focus', this.startMutationObserver, {
        capture: true
      });
    }
  }, {
    key: 'captureFocus',
    value: function captureFocus() {
      // If the focus is currently within the page (or null/<body>), focus on this
      // dialog so that tabbing works. We *don't* want to capture focus if the
      // element is in a non-page element, e.g. a popover or other modal.
      var dialog = (0, _reactDom.findDOMNode)(this._ref);
      if (!dialog) return;

      var activeElement = document.activeElement;
      var dialogContainsActiveElement = dialog.contains(activeElement);
      var shouldCapture = false;
      if (!activeElement || activeElement === document.body) {
        shouldCapture = true;
      } else if (!dialogContainsActiveElement) {
        // A few weird apps have multiple .page elements...
        var pages = document.querySelectorAll('body > .page');
        for (var i = 0; i < pages.length; i++) {
          if (pages[i].contains(activeElement)) {
            shouldCapture = true;
            break;
          }
        }
      }
      // Also, we also want to move focus to the dialog if the focus has somehow
      // wound up on a non-focusable element *within* the dialog.
      if (dialogContainsActiveElement && !(0, _Dom.matches)(activeElement, _Selectors.FOCUSABLE)) {
        shouldCapture = true;
      }
      if (shouldCapture) {
        dialog.focus();
      }
    }
  }, {
    key: 'refCallback',
    value: function refCallback(ref) {
      this._ref = ref;
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(evt) {
      var onEsc = this.props.onEsc;

      var dialog = (0, _reactDom.findDOMNode)(this._ref);
      if (!dialog) return;

      if (evt.key === 'Tab') {
        // Based on https://www.w3.org/TR/wai-aria-practices/#trap_focus_div
        var activeElement = document.activeElement;
        var allFocusableElements = dialog.querySelectorAll(_Selectors.FOCUSABLE);
        var firstFocusableElement = (0, _underscore.first)(allFocusableElements);
        var lastFocusableElement = (0, _underscore.last)(allFocusableElements);

        if (evt.shiftKey) {
          // Shift+Tab: If focus is on first element, cycle to last element
          if (activeElement === firstFocusableElement || activeElement === dialog) {
            evt.preventDefault();
            lastFocusableElement.focus();
          }
        } else {
          // Unmodified Tab: If focus is on last element, cycle to first element
          if (activeElement === lastFocusableElement || activeElement === dialog) {
            evt.preventDefault();
            firstFocusableElement.focus();
          }
        }
      } else if (evt.key === 'Escape') {
        if (typeof onEsc === 'function') {
          onEsc(evt);
        } else {
          var closeButton = dialog.querySelector('[data-action=close]');
          if (closeButton) closeButton.click();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          centered = _props.centered,
          children = _props.children,
          className = _props.className,
          contextual = _props.contextual,
          dialogClassName = _props.dialogClassName,
          _dialogWidth = _props._dialogWidth,
          __onEsc = _props.onEsc,
          role = _props.role,
          size = _props.size,
          use = _props.use,
          _use = _props._use,
          __closeStartRelay = _props._closeStartRelay,
          __openCompleteRelay = _props._openCompleteRelay,
          rest = _objectWithoutProperties(_props, ['centered', 'children', 'className', 'contextual', 'dialogClassName', '_dialogWidth', 'onEsc', 'role', 'size', 'use', '_use', '_closeStartRelay', '_openCompleteRelay']);

      var openComplete = this.state.openComplete;


      var computedUse = _use || use;

      // If one of the children is <UIDialogCloseButton detached>, render it in
      // the overlay instead of the dialog.
      var closeButton = null;
      var dialogChildren = _react2.default.Children.map(children, function (child) {
        if (child === null) {
          return null;
        } else if (child.type === _UIDialogCloseButton2.default && child.props.detached) {
          closeButton = child;
          return null;
        }
        return child;
      });

      var centerContent = ['fullscreen', 'sidebar', 'lightbox'].indexOf(computedUse) === -1;
      return _react2.default.createElement(
        _UIOverlay2.default,
        _extends({}, rest, {
          centerContent: centerContent,
          className: (0, _classNames2.default)(className, 'private-modal-dialog--overlay'),
          contextual: contextual,
          'data-component-name': 'UIModalDialog',
          'data-open-complete': openComplete,
          onKeyDown: this.handleKeyDown,
          ref: this.refCallback,
          tabIndex: -1
        }),
        _react2.default.createElement(
          _UIDialog2.default,
          {
            _dialogWidth: _dialogWidth,
            centered: centered,
            className: dialogClassName,
            role: role !== undefined ? role : 'dialog',
            size: size,
            use: computedUse
          },
          dialogChildren
        ),
        closeButton
      );
    }
  }]);

  return UIModalDialog;
}(_react2.default.Component);

UIModalDialog.propTypes = {
  centered: _react.PropTypes.bool.isRequired,
  children: _react.PropTypes.node,
  contextual: (0, _decorators.hidden)(_react.PropTypes.bool),
  _dialogWidth: _UIDialog2.default.propTypes._dialogWidth,
  dialogClassName: _react.PropTypes.string,
  onEsc: _react.PropTypes.func,
  onOverlayClick: _react.PropTypes.func,
  size: _react.PropTypes.oneOf(Object.keys(_DialogConstants.SIZE_CLASSES)),
  use: _react.PropTypes.oneOf(Object.keys(_DialogConstants.DIALOG_USE_CLASSES)),
  _use: _react.PropTypes.oneOf(['sidebar']),
  width: _UIOverlay2.default.propTypes.width,
  _openCompleteRelay: _react.PropTypes.object,
  _closeStartRelay: _react.PropTypes.object
};

UIModalDialog.contextTypes = {
  sandboxed: _react.PropTypes.bool
};

UIModalDialog.defaultProps = {
  centered: false,
  contextual: false,
  use: 'default',
  size: 'auto',
  width: 450
};

UIModalDialog.displayName = 'UIModalDialog';

exports.default = UIModalDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/dialog/UIModalDialog.js
// module id = 198
// module chunks = 3 4 5